import React from 'react'

import { RightImageContent } from '..'
import { SectionProps } from '../../../../core/types/Help'
import { SectionTitle, Text } from '../ContentItem'
import { HELP_IMAGES } from '../../../constants/HelpImages'
import { buildDynamicCopy } from '../../../../core/utils/Localization'

const CashFlow: React.FC<SectionProps> = ({ copy, topicKey }) => {
  const contentMap = {
    'cash-flow-overview': (
      <React.Fragment>
        <RightImageContent
          altImage={copy.cashflow_overview.alt_image}
          content={
            <React.Fragment>
              <Text
                content={copy.cashflow_overview.widget_overview_instruction_1}
                sx={{ mt: 24 }}
              />
              <Text
                content={copy.cashflow_overview.widget_overview_instruction_2}
                sx={{ mt: 12 }}
              />
            </React.Fragment>
          }
          image={HELP_IMAGES.CASHFLOW_WIDGET}
          sx={{ pt: 8 }}
        />
        <RightImageContent
          altImage={copy.cashflow_overview.alt_image_expense_details}
          content={
            <Text
              content={
                buildDynamicCopy(
                  copy.cashflow_overview.expense_details_instruction,
                  <b>{copy.cashflow_overview.edit_expense_details_bold_1}</b>,
                ) as React.ReactNode
              }
              sx={{ mt: 24 }}
            />
          }
          image={HELP_IMAGES.CASHFLOW_MANAGE_EXPENSES}
          sx={{ pt: 48 }}
        />
        <SectionTitle
          content={copy.cashflow_overview.manage_expenses_section_title}
          sx={{ pt: 48 }}
        />
        <RightImageContent
          altImage={copy.cashflow_overview.alt_image_manage_expenses}
          content={
            <Text content={copy.cashflow_overview.manage_expenses_instruction} sx={{ mt: 24 }} />
          }
          hasDivider={false}
          image={HELP_IMAGES.CASHFLOW_EXPENSE_DETAILS}
        />
      </React.Fragment>
    ),
  }
  return contentMap[topicKey as keyof typeof contentMap]
}

export default CashFlow
